module.exports = __webpack_public_path__ + "1373d4ec7fdd4b409729ecad1abc16d1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/spiral-notebook.png
// module id = 3052
// module chunks = 0